import type { OcIconV1Props } from "../../icon";

/**
 *
 */
export const iconTypeByBannerType = {
  error: "clear",
  success: "success-hint",
  warning: "warning-hint",
  hint: "question-hint",
  info: "info-hint",
} satisfies Record<string, OcIconV1Props["type"]>;
